import { Component, OnInit, Input, EventEmitter, Output, DoCheck } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from '../../../login/service/login.service';
import { SistemasLista } from '../../dominios/sistemas-lista.modules';
import { StorafeUtil } from '../../util/storasge.util';
import { MODO_PERSPECTIVA_ITENS_MENU_USUARIO, CODIGO_CENTRUS, PERMISSAO_ALTERAR_SENHA_USUARIO, PERMISSAO_ITENS_MENU_USUARIO } from '../../../../app.constants';
import { PessoaDadosSimplicadosModel } from '../../models/pessoa-simplificada.model';
import { PessoaService } from '../../services/pessoa.service';
import { AuthInterceptor } from '../../../interceptor/auth.interceptor';
import { ValidarPermissaoFuncionalidadeService } from '../../services/validar-permissao-funcionalidades.service';
import { PessoaCompletaModel } from '../../models/pessoa-completa.model';

@Component({
    selector: 'app-header-inicial',
    templateUrl: './header-inicial.component.html',
    styleUrls: ['./header-inicial.component.css']
})
export class HeaderInicialComponent implements OnInit, DoCheck {

    @Input() sistemasLista: SistemasLista[] = [];
    @Input() mobileMenuActive: Boolean;


    menuButtonClick: boolean;
    @Output() ativarMenuMobile = new EventEmitter();


    activeTopbarItem: any;
    topbarMenuClick: boolean;
    layoutStatic: boolean;
    menuClick: boolean;
    disabled: boolean;

    habilidatarAlterarSenha: Boolean = true;

    pessoaCompletaModel = new PessoaCompletaModel();

    constructor(
        private router: Router,
        private pessoaService: PessoaService,
        private authInterceptor: AuthInterceptor,
        private validarPermissaoFuncionalidadeService: ValidarPermissaoFuncionalidadeService,
        private loginService: LoginService
    ) { }

    ngDoCheck(): void {
        this.getDadosSesseionStorage();

    }

    ngOnInit() {
        this.getPessoasDadosSimplificado();

        ValidarPermissaoFuncionalidadeService.atualiazarItemMenu.subscribe(arg => {
            const modoConsultadoUusario = StorafeUtil.recuperarSessionStorage(MODO_PERSPECTIVA_ITENS_MENU_USUARIO);
            const permissaoAlterarSenhaUsuario = StorafeUtil.recuperarSessionStorage(PERMISSAO_ALTERAR_SENHA_USUARIO);
            (modoConsultadoUusario && !permissaoAlterarSenhaUsuario) ? (this.habilidatarAlterarSenha = false) : (this.habilidatarAlterarSenha = true);

            (modoConsultadoUusario) ? (this.getPessoasDadosSimplificado()) : (this.getPessoasDadosSimplificado());
        })
    }


    async getPessoasDadosSimplificado() {
        try {
            const modoConsultadoUusario = StorafeUtil.recuperarSessionStorage(MODO_PERSPECTIVA_ITENS_MENU_USUARIO);
            const recuperandoObjeto = StorafeUtil.recuperarSessionStorage(CODIGO_CENTRUS);
            const cdCentrus = (recuperandoObjeto && modoConsultadoUusario) ? (Number(recuperandoObjeto)) : (this.authInterceptor.getJwtCdCentrus());
            this.pessoaCompletaModel = await this.pessoaService.getPessoa(cdCentrus);
        } catch (error) {
        }
    }




    getDadosSesseionStorage(): void {
        try {
            const recuperandoObjeto = StorafeUtil.recuperarSessionStorage(MODO_PERSPECTIVA_ITENS_MENU_USUARIO);
            if (recuperandoObjeto) { this.disabled = Boolean(recuperandoObjeto) };

        } catch (error) {
            console.error(error);
        }
    }

    alterarSenha() {
        this.router.navigateByUrl('recuperarSenha/alterarSenha', { replaceUrl: true });
    }

    sair() {
        this.loginService.logout();
    }

    navegarEvent(event) {
        window.location.href = event.routerLink;
    }


    onMenuButtonClick(event: Event) {
        if (this.isMobile()) { this.ativarMenuMobile.emit({ mobileMenuAtivo: !this.mobileMenuActive, menuButtonClick: true }) }

    }


    onTopbarRootItemClick(event: Event, item: Element) {
        if (this.activeTopbarItem === item) {
            this.activeTopbarItem = null;
        } else {
            this.activeTopbarItem = item;
        }

        event.preventDefault();
    }

    onTopbarMenuClick(event: Event) {
        this.topbarMenuClick = true;
    }

    onSidebarClick(event: Event) {
        this.menuClick = true;
    }

    onToggleMenuClick(event: Event) {
        this.layoutStatic = !this.layoutStatic;
    }

    isMobile(): Boolean {
        return window.innerWidth < 640;
    }

    sairDaPerspectivaUsuario(): void {
        StorafeUtil.limparSessionStorage(MODO_PERSPECTIVA_ITENS_MENU_USUARIO);
        StorafeUtil.limparSessionStorage(PERMISSAO_ITENS_MENU_USUARIO);
        StorafeUtil.limparSessionStorage(CODIGO_CENTRUS);
        this.disabled = false;
        this.router.navigateByUrl('/home', { skipLocationChange: true }).then(() => this.router.navigate([decodeURI('/home')]));
        ValidarPermissaoFuncionalidadeService.atualiazarItemMenu.emit(false)

    }


}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/layout/header-inicial/header-inicial.component.ts